export default __webpack_public_path__ + "static/media/embedded-payroll.3bdb86e5.png";